import { render, staticRenderFns } from "./DetailsPage.vue?vue&type=template&id=185406b2&scoped=true"
import script from "./DetailsPage.vue?vue&type=script&lang=js"
export * from "./DetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DetailsPage.vue?vue&type=style&index=0&id=185406b2&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185406b2",
  null
  
)

export default component.exports